module.exports = __webpack_public_path__ + "img/1509636588.a32ee0b9.jpg";